import PropTypes from 'prop-types';

import classes from 'styles/pages/About/About.module.scss';
import Typography from './Typography';

const MemberBio = ({ name, title, bio, imageName, left, blue }) => {
  return (
    <>
      <div className={left ? classes.bioBoxLeft : classes.bioBoxRight}>
        <img src={`about/${imageName}`} className={classes.photo} alt={name} />
        <div>
          <div className={blue ? classes.bioHeaderBlue : classes.bioHeaderGreen}>
            <Typography variant="h2">
              <b>{name}</b>
            </Typography>
            <Typography variant="h4">{title}</Typography>
          </div>
          {bio.map((text, i) => (
            <div key={i}>
              <Typography>{text}</Typography>
              <br />
            </div>
          ))}
        </div>
      </div>

      <div className={classes.gradientBar} />
    </>
  );
};

MemberBio.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  bio: PropTypes.string.isRequired,
  imageName: PropTypes.string.isRequired,
  left: PropTypes.bool.isRequired,
  blue: PropTypes.bool.isRequired,
};

export default MemberBio;
